import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import SupplierAppShell from './SupplierAppShell';
import Dashboard from './pages/Dashboard';
import POList from './pages/POList';
import PODetail from './pages/PODetail';
import PORespond from './pages/PORespond';
import Profile from './pages/Profile';
import Catalog from './pages/Catalog/Catalog';
import Inventory from './pages/Inventory/Inventory';
import ConnectedRestaurants from './pages/ConnectedRestaurants/ConnectedRestaurants';

export const supplierRoutes = (
  <>
    <Route path="/supplier/respond/:token" element={<PORespond />} />
    <Route path="/supplier/*" element={<SupplierAppShell />}>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="orders" element={<POList />} />
      <Route path="orders/:restroId/:id" element={<PODetail />} />
      <Route path="profile" element={<Profile />} />
      <Route path="catalog" element={<Catalog />} />
      <Route path="inventory" element={<Inventory />} />
      <Route path="restaurants" element={<ConnectedRestaurants />} />
    </Route>
  </>
);
